'use strict';

export default class Content {
  constructor() {
    this.name = 'content';
    const tooltip = document.querySelectorAll('.tooltip');
    let observer;
    window.addEventListener('scroll', () => {
      for (let i = 0; i < tooltip.length; i++) {
        tooltip[i].style.transform = 'translateY(-' + (window.pageYOffset * 0.05) + 'px)';
      }
    }, false);

    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          console.log('On Viewport', entry.target.src);
          entry.target.src = entry.target.src;
        }
        else {
          console.log('Out of Viewport');
        }
      });
    });

    tooltip.forEach(tootlipp => {
      observer.observe(tootlipp);
    });

  }
}
